import { render, staticRenderFns } from "./embed_survey.vue?vue&type=template&id=618def8f&scoped=true&"
import script from "./embed_survey.vue?vue&type=script&lang=js&"
export * from "./embed_survey.vue?vue&type=script&lang=js&"
import style0 from "./embed_survey.vue?vue&type=style&index=0&id=618def8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618def8f",
  null
  
)

export default component.exports